import type React from 'react'
import { useState } from 'react'
import { formatNumber } from '@/lib/format-utils'

/**
 * 金額入力フィールド用のフォーマットフック。
 * 非フォーカス時はカンマ区切りで表示し、フォーカス中は生の数値文字列を表示する。
 * 非数字の入力は自動的に除去される。
 */
export function useFormattedNumberInput(value: string, onValueChange: (raw: string) => void) {
  const [isFocused, setIsFocused] = useState(false)

  return {
    inputMode: 'numeric' as const,
    value: isFocused ? value : value !== '' ? formatNumber(Number(value)) : '',
    onFocus: () => setIsFocused(true),
    onBlur: () => setIsFocused(false),
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
      const raw = e.target.value.replace(/[^\d]/g, '')
      onValueChange(raw)
    },
  }
}
